export type MaisMenuLink = { label: string; to: string };

export type MaisMenuGroup =
  | { kind: "links"; items: MaisMenuLink[] }
  | { kind: "submenu"; label: string; items: MaisMenuLink[] };

export const METAS_MENU_ITEMS: MaisMenuLink[] = [
  { label: "Meta Coletiva", to: "/metas/coletiva" },
  { label: "Meta Individual", to: "/metas/individual" },
];

/** Menu principal (Header) e sidebar — fora do dropdown “Mais”. */
export const RODIZIO_MENU_ITEMS: MaisMenuLink[] = [
  { label: "Sequência", to: "/rodizio" },
  { label: "Urgência", to: "/rodizio/urgencia" },
];

export const DESENVOLVEDOR_MENU_ITEMS: MaisMenuLink[] = [
  { label: "Correções em produção", to: "/ferramentas-desenvolvedor" },
  { label: "Monitoramento", to: "/monitoramento" },
  { label: "Backups", to: "/backups" },
  { label: "Crons", to: "/crons" },
];

export const APP_MENU_ITEMS: MaisMenuLink[] = [
  { label: "Atualizar APK", to: "/atualizar-apk" },
  { label: "Mensagens mobile", to: "/mensagens-mobile" },
];

/** Menu principal — Controle de Produção (fora do dropdown “Mais”). */
export const CONTROLE_PRODUCAO_MENU_GROUPS: MaisMenuGroup[] = [
  {
    kind: "submenu",
    label: "Cadastro",
    items: [
      { label: "Unidades de Medida", to: "/controle-producao/und-medida" },
      { label: "Itens de Produção", to: "/controle-producao/itens" },
      { label: "Setores de Produção", to: "/controle-producao/setores" },
      { label: "Funcionamento Produção", to: "/controle-producao/funcionamento" },
      { label: "Cadastro Base Semanal", to: "/controle-producao/base-semanal" },
    ],
  },
  {
    kind: "submenu",
    label: "Ficha",
    items: [
      { label: "Preencher Ficha Diária", to: "/controle-producao/ficha-diaria" },
      { label: "Ficha de Transferência", to: "/controle-producao/ficha-transferencia" },
      { label: "Sobras", to: "/controle-producao/sobras" },
    ],
  },
  {
    kind: "submenu",
    label: "Relatórios",
    items: [
      {
        label: "Relatório Consumo",
        to: "/controle-producao/relatorio-consumo",
      },
      {
        label: "Desempenho Produção",
        to: "/controle-producao/relatorio-tempos",
      },
      {
        label: "Equipe por Setor",
        to: "/controle-producao/relatorio-equipe",
      },
    ],
  },
];

export const MAIS_MENU_GROUPS: MaisMenuGroup[] = [
  { kind: "submenu", label: "Metas", items: METAS_MENU_ITEMS },
  {
    kind: "links",
    items: [
      { label: "Lojas", to: "/lojas" },
      { label: "Inspeção", to: "/inspecao" },
    ],
  },
  {
    kind: "submenu",
    label: "Catálogo",
    items: [
      { label: "Cardápio", to: "/cardapio" },
      { label: "Bordas", to: "/bordas" },
      { label: "Tamanhos", to: "/tamanhos" },
    ],
  },
  {
    kind: "submenu",
    label: "Operação",
    items: [
      { label: "Filas Integração", to: "/filas-integracao" },
      { label: "Fila de Porções", to: "/fila-porcoes" },
      { label: "Fila de Bebidas", to: "/fila-bebidas" },
      { label: "Sequência do dia", to: "/sequencia-pedidos" },
    ],
  },
  {
    kind: "submenu",
    label: "Entregas",
    items: [{ label: "Aguardando Entrega", to: "/aguardando-entrega" }],
  },
  {
    kind: "submenu",
    label: "Histórico",
    items: [
      { label: "Histórico geral", to: "/historicos" },
      { label: "Pulo por falta de borda", to: "/historico-pulo-borda" },
      { label: "Pendentes excluídos", to: "/limpeza-pendentes" },
    ],
  },
  {
    kind: "links",
    items: [{ label: "Whatsapp", to: "/whatsapp" }],
  },
];

export function filterMaisMenuGroups(
  groups: MaisMenuGroup[],
  canAccess: (path: string) => boolean,
  options?: { includeFichaDiaria?: boolean }
): MaisMenuGroup[] {
  const result: MaisMenuGroup[] = [];

  for (const group of groups) {
    let items = group.items.filter((item) => canAccess(item.to));

    if (
      options?.includeFichaDiaria &&
      group.items.some((i) => i.to === "/controle-producao/ficha-diaria") &&
      !items.some((i) => i.to === "/controle-producao/ficha-diaria")
    ) {
      items = [
        ...items,
        {
          label: "Preencher Ficha Diária",
          to: "/controle-producao/ficha-diaria",
        },
      ];
    }

    if (items.length === 0) continue;

    if (group.kind === "submenu" && items.length === 1) {
      result.push({ kind: "links", items });
      continue;
    }

    result.push(group.kind === "submenu" ? { ...group, items } : { kind: "links", items });
  }

  return result;
}

export function flattenMaisMenuGroups(groups: MaisMenuGroup[]): MaisMenuLink[] {
  return groups.flatMap((group) => group.items);
}
